export const CART_CONTINUE_STATUSES = {
  DELIVERY_REQUIRED: 'DELIVERY_REQUIRED',
  PAYMENT_REQUIRED: 'PAYMENT_REQUIRED'
};

export const ORDER_LINE_SOURCE = {
  LANDING_PAGE: 'LANDING_PAGE'
};

export enum CART_PROMO_CODE_TYPES {
  BAKERY = 'BAKERY',
  STORE = 'STORE',
  GIFT_CARD = 'GIFT_CARD',
}

export const GIFT_CARD_ERROR_CODE = {
  EXPIRED: 'EXPIRED',
  EMPTY: 'EMPTY',
  NOT_VALID: 'NOT_VALID',
  NOT_FOUND: 'NOT_FOUND',
  PAYMENT_NOT_ALLOW: 'PAYMENT_NOT_ALLOW',
};

export enum PROMO_CODE_ERROR_CODES {
  SCHEMA_API_EXCEPTION = 'SCHEMA_API_EXCEPTION',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  DISCOUNT_NOT_FOUND = 'DISCOUNT_NOT_FOUND',
  MISSING_DELIVERY_DATE = 'MISSING_DELIVERY_DATE',
  DISCOUNT_INVALID_DATE = 'DISCOUNT_INVALID_DATE',
  DISCOUNT_ALREADY_REDEEMED_BY_USER = 'DISCOUNT_ALREADY_REDEEMED_BY_USER'
}
